<script>
import BusienssService from "@/services/Business";
import Customers from "@/services/Customers";
import Swal from "sweetalert2";

export default {
    props: {
      selectedCompanyData: {
            type: Object,
        }
    },
  data() {
    return {
        selectedCompany: {},
        companies:[],
        selectedUser:null,
        tryingToEdit: false,
    };
  },
  methods: {
      async getExternalCompanies(){
          try {

              this.toggleBusy();

              const response = await Customers.getExternalCompanies('exclude_attached=true')
              this.companies = response.data.data
          } catch (error) {
              this.error = error.response.data.error ? error.response.data.error : "";
              this.companies = null
          } finally {
              this.toggleBusy();
          }
    },
    async saveChanges() {
        if (!this.selectedCompanyData || !this.selectedCompanyData.company_id) {
            console.error("Company data is missing.");
            return;
        }

        this.tryingToEdit = true;
        const payload = {
          company_id:this.selectedCompanyData.company_id,
          external_company_id: this.selectedCompany,
        };

        try {

            const response = await Customers.attachExternalCompany(payload);
            if (response.status >= 200 && response.status < 300) {
              // Emit event for parent to update after save
              this.$emit('onRefresh');  // Emit refreshTable only after saving
              this.$bvModal.hide('attach_external_company_modal');  // Close the modal after save
            } else {
              Swal.fire("Fail!", "Error Attaching External Company", "warning");
            }
        } catch (error) {
            this.tryingToEdit = false;
            let errorMessage = error.response && error.response.data && error.response.data.error
              ? error.response.data.error
              : "Error Attaching External Company"
            if (typeof errorMessage === 'object') {
              errorMessage = errorMessage[0];
            }
            Swal.fire("Fail!", errorMessage, "warning");
        }

        this.tryingToEdit = false;
    },

    closeModal() {
        // Only hide the modal, no page reload or table refresh here
        this.$bvModal.hide('attach_external_company_modal');
        this.selectedCompany={}
    },
  },


};
</script>

<template>
  <b-modal id="attach_external_company_modal" title="Attach External Company" @hidden="closeModal" @shown="getExternalCompanies" size="xl" centered>
    <template v-slot:default>
      <div class="row">
        <div class="col-sm-6">
          <b-form-group label="Select External Company">
              <b-form-select
                      v-model="selectedCompany"
                      :options="companies.map(company => ({ text: company.name, value: company.external_company_id }))"
                      placeholder="Select a company">
              </b-form-select>

          </b-form-group>
        </div>
      </div>
    </template>
    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Cancel</b-button>
      <b-button variant="primary" @click="saveChanges" :disabled="tryingToEdit">Save Changes
        <b-spinner v-show="tryingToEdit" small></b-spinner>
      </b-button>
    </template>
  </b-modal>
</template>
